export function showToast(message: string, type: 'INFO' | 'ERROR' | 'WARN') {
    const detail = { message, type }
    const event = new CustomEvent('show-toast', { detail })
    document.dispatchEvent(event)
}
